import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './src/ui/__generated__/uiOnboardingGetStartedPageQuery.graphql';

export const softwareOnboardingGetStartedEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-onboarding-get-started-entrypoint" */ './src/ui/index.tsx'
			),
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => ({
		// Queries your async component uses
		queries: {
			onboardingGetStartedPageData: {
				parameters,
				variables: {
					siteAri: `ari:cloud:jira::site/${tenantContext.cloudId}`,
					cloudId: tenantContext.cloudId,
				},
			},
		},
		// Optional - Any nested EntryPoints you wish to also load
		entryPoints: {},
		// Optional - Anything extra you wish to pass to your component
		// Something from `EntryPointParams` for example
		extraProps: {},
	}),
});
